export function createApiClient(csrfToken) {
  function headers(withBody = false) {
    const h = {
      "Accept": "application/json",
      "X-CSRF-Token": csrfToken,
    };
    if (withBody) h["Content-Type"] = "application/json";
    return h;
  }

  async function request(url, options = {}) {
    const response = await fetch(url, { credentials: "same-origin", ...options });
    if (!response.ok) {
      let message = `Request failed (${response.status})`;
      try {
        const body = await response.json();
        if (body.errors) {
          message = Array.isArray(body.errors) ? body.errors.join(", ") : body.errors;
        }
      } catch {
        // ignore parse errors
      }
      throw new Error(message);
    }
    if (response.status === 204) return null;
    return response.json();
  }

  return {
    getRigs() {
      return request("/api/rigs", { headers: headers() });
    },

    getRig(id) {
      return request(`/api/rigs/${id}`, { headers: headers() });
    },

    createRig(name) {
      return request("/api/rigs", {
        method: "POST",
        headers: headers(true),
        body: JSON.stringify({ rig: { name } }),
      });
    },

    updateRig(id, attrs) {
      return request(`/api/rigs/${id}`, {
        method: "PATCH",
        headers: headers(true),
        body: JSON.stringify({ rig: attrs }),
      });
    },

    syncRig(id, board) {
      return request(`/api/rigs/${id}/sync`, {
        method: "PATCH",
        headers: headers(true),
        body: JSON.stringify({ board }),
      });
    },

    reorderRigs(rigIds) {
      return request("/api/rigs/reorder", {
        method: "PATCH",
        headers: headers(true),
        body: JSON.stringify({ rig_ids: rigIds }),
      });
    },

    duplicateRig(id) {
      return request(`/api/rigs/${id}/duplicate`, {
        method: "POST",
        headers: headers(),
      });
    },

    deleteRig(id) {
      return request(`/api/rigs/${id}`, {
        method: "DELETE",
        headers: headers(),
      });
    },
  };
}
